import { render, staticRenderFns } from "./styled-plaintext.vue?vue&type=template&id=1b2d6c6e&"
import script from "./styled-plaintext.vue?vue&type=script&lang=js&"
export * from "./styled-plaintext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports